// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IPlaceOrderRequestModel {
    static getAttributeTypeMap() {
        return IPlaceOrderRequestModel.attributeTypeMap;
    }
}
IPlaceOrderRequestModel.discriminator = undefined;
IPlaceOrderRequestModel.additionalProperties = false;
IPlaceOrderRequestModel.attributeTypeMap = [
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "orderTypeId",
        "baseName": "orderTypeId",
        "type": "number"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "address2",
        "baseName": "address2",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "postalCode",
        "baseName": "postalCode",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "uploadFile",
        "baseName": "uploadFile",
        "type": "IClaimFileModel"
    },
];
//# sourceMappingURL=iPlaceOrderRequestModel.js.map